/* STEP 12-3 · lane S12C (owner card Step 12 V4, section C — one Export button: Excel, Word and PDF) — EN + AR of the Export
   drop-down on the IFRS statements page (FsExportMenu.jsx), the "These notes do not tie" message shown before an export
   (card A0.4: the export still goes ahead), the note that the Excel / Word files are in English for now (card C5), and the
   kind of each row of the publication audit trail. No standard paragraph is quoted. */
const I18N_S12C = {
  en: {
    s12c: {
      exportBtn: "Export",
      excel: "Excel (.xlsx)",
      word: "Word (.docx)",
      pdf: "PDF (Publication PDF)",
      englishOnly: "Export is in English for now.",
      building: "Building the {kind} file…",
      done: "{kind} file downloaded.",
      failed: "The {kind} file could not be built.",
      blocked: "The export is blocked: {n} statement check(s) fail. See Validation.",
      untiedTitle: "These notes do not tie:",
      untiedRow: "Note {n} {title}: difference {diff}",
      untiedMore: "+{n} more",
      untiedGoAhead: "The export goes ahead.",
      kind: { pdf: "PDF", xlsx: "Excel", docx: "Word" },
    },
  },
  ar: {
    s12c: {
      exportBtn: "تصدير",
      excel: "Excel (.xlsx)",
      word: "Word (.docx)",
      pdf: "PDF (ملف PDF للنشر)",
      englishOnly: "التصدير باللغة الإنجليزية حاليًا.",
      building: "جارٍ إعداد ملف {kind}…",
      done: "تم تنزيل ملف {kind}.",
      failed: "تعذّر إعداد ملف {kind}.",
      blocked: "التصدير موقوف: {n} من فحوصات القوائم غير مطابقة. راجع التحقق.",
      untiedTitle: "هذه الإيضاحات غير مطابقة:",
      untiedRow: "إيضاح {n} {title}: الفرق {diff}",
      untiedMore: "+{n} أخرى",
      untiedGoAhead: "يستمر التصدير.",
      kind: { pdf: "PDF", xlsx: "Excel", docx: "Word" },
    },
  },
};

export default I18N_S12C;
